import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    projectType: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.currentTarget;
      const formDataToSend = new FormData(formElement);

      const response = await fetch('https://readdy.ai/api/form/d6e3jb3v53dtlm7j8upg', {
        method: 'POST',
        body: new URLSearchParams(formDataToSend as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', projectType: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-32 px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl md:text-7xl font-extralight text-white mb-6">
            Let's Create Something
          </h2>
          <p className="text-[#71717a] text-xl">
            Available for documentary/film projects&nbsp; and collaborations
          </p>
        </div>

        {/* Contact form */}
        <div className="max-w-[600px] mx-auto">
          <form
            id="contact-form"
            data-readdy-form
            onSubmit={handleSubmit}
            className="bg-[#18181b]/60 backdrop-blur-sm p-10 rounded-3xl space-y-6"
          >
            <div>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="w-full bg-[#0a0a0a] text-white placeholder-[#52525b] px-6 py-4 rounded-2xl border-none focus:outline-none focus:ring-2 focus:ring-[#14b8a6] transition-all duration-300"
              />
            </div>

            <div>
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full bg-[#0a0a0a] text-white placeholder-[#52525b] px-6 py-4 rounded-2xl border-none focus:outline-none focus:ring-2 focus:ring-[#14b8a6] transition-all duration-300"
              />
            </div>

            <div>
              <select
                name="projectType"
                value={formData.projectType}
                onChange={(e) => setFormData({ ...formData, projectType: e.target.value })}
                required
                className="w-full bg-[#0a0a0a] text-white placeholder-[#52525b] px-6 py-4 rounded-2xl border-none focus:outline-none focus:ring-2 focus:ring-[#14b8a6] transition-all duration-300 cursor-pointer"
              >
                <option value="" disabled>
                  Project Type
                </option>
                <option value="documentary">Documentary</option>
                <option value="commercial">Commercial</option>
                <option value="music-video">Music Video</option>
                <option value="corporate">Corporate</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <textarea
                name="message"
                placeholder="Tell me about your project..."
                value={formData.message}
                onChange={(e) => {
                  if (e.target.value.length <= 500) {
                    setFormData({ ...formData, message: e.target.value });
                  }
                }}
                required
                rows={6}
                maxLength={500}
                className="w-full bg-[#0a0a0a] text-white placeholder-[#52525b] px-6 py-4 rounded-2xl border-none focus:outline-none focus:ring-2 focus:ring-[#14b8a6] transition-all duration-300 resize-none"
              />
              <div className="text-right text-[#52525b] text-xs mt-2">
                {formData.message.length}/500
              </div>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#14b8a6] hover:bg-[#0d9488] text-white py-4 rounded-full font-medium transition-all duration-300 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>

            {submitStatus === 'success' && (
              <div className="text-center text-[#84cc16] text-sm mt-4">
                Message sent successfully! I'll get back to you soon.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="text-center text-[#ec4899] text-sm mt-4">
                Something went wrong. Please try again.
              </div>
            )}
          </form>

          {/* Direct contact info */}
          <div className="mt-12 text-center space-y-4">
            <p className="text-[#71717a] text-sm uppercase tracking-wider">Or reach out directly</p>
            <a
              href="mailto:omarhid123321@gmail.com"
              className="block text-[#14b8a6] text-lg hover:text-[#0d9488] transition-colors duration-300"
            >
              omarhid123321@gmail.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
